import { CreditCard, ChevronDown, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { usePaymentGatewaysQuery } from '@/hooks/business/usePaymentGatewaysQuery'

interface Props {
  selectedPaymentGateways: string[]
  onPaymentGatewayChange: (_paymentGateways: string[]) => void
}

export const PaymentGatewayDropdown = ({
  selectedPaymentGateways,
  onPaymentGatewayChange,
}: Props) => {
  const { businessData, isLoadingBusinessData } = useBusinessDataQuery({})
  const { paymentGateways, isLoadingPaymentGateways } = usePaymentGatewaysQuery(
    {
      businessId: businessData?.id ?? 0,
      options: { enabled: !!businessData?.id && !isLoadingBusinessData },
    }
  )

  const handleToggle = (gatewayValue: string) => {
    const currentSelection = [...selectedPaymentGateways]
    const index = currentSelection.indexOf(gatewayValue)

    if (index > -1) {
      currentSelection.splice(index, 1)
    } else {
      currentSelection.push(gatewayValue)
    }

    onPaymentGatewayChange(currentSelection)
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          aria-label="Métodos de pago"
          className="gap-1.5"
          variant="outline"
        >
          <CreditCard className="h-4 w-4" />
          <span>
            {selectedPaymentGateways.length > 0
              ? `${selectedPaymentGateways.length} seleccionado(s)`
              : 'Métodos de pago'}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[280px] p-3">
        <div className="space-y-3">
          {!paymentGateways || isLoadingPaymentGateways ? (
            <div className="flex items-center justify-center">
              <Loader2 className="h-4 w-4 animate-spin" />
            </div>
          ) : (
            paymentGateways.map((option) => (
              <div className="flex items-center space-x-2" key={option.id}>
                <Checkbox
                  checked={selectedPaymentGateways.includes(
                    option.id.toString()
                  )}
                  id={`payment-${option.id}`}
                  onCheckedChange={() => handleToggle(option.id.toString())}
                />
                <Label
                  className="cursor-pointer text-sm font-normal"
                  htmlFor={`payment-${option.id}`}
                >
                  {option.name}
                </Label>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}
